(function(){
  var pop = document.getElementById('PfPop'); if (!pop) return;
  var KEY = 'pfPopUntil', DONE = 'pfPopDone';
  function get(k){ try { return localStorage.getItem(k); } catch(e) { return null; } }
  function set(k, v){ try { localStorage.setItem(k, v); } catch(e) {} }
  var done = pop.querySelector('[data-pf-done]');
  var lastFocus = null;
  function busy(){
    var a = document.activeElement;
    if (a && a !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !pop.contains(a)) return true;
    return !!document.querySelector('details[open] .search-modal, details-modal details[open], cart-drawer.active, .menu-drawer-container[open], .drawer.active, product-modal[open]');
  }
  function open(focusField){
    if (!pop.hidden) return;
    lastFocus = document.activeElement;
    pop.hidden = false; document.documentElement.classList.add('pf-pop-open');
    requestAnimationFrame(function(){ pop.classList.add('is-in'); });
    var f = focusField ? pop.querySelector('#PfPopEmail, [data-pf-copy]') : pop.querySelector('.pf-pop__x');
    if (f) setTimeout(function(){ f.focus({ preventScroll: true }); }, 60);
  }
  function close(){
    if (pop.hidden) return;
    pop.classList.remove('is-in'); document.documentElement.classList.remove('pf-pop-open');
    setTimeout(function(){ pop.hidden = true; }, 200);
    if (!done) set(KEY, String(Date.now() + (parseInt(pop.dataset.days, 10) || 14) * 864e5));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  pop.querySelectorAll('[data-pf-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !pop.hidden) close(); });
  var copy = pop.querySelector('[data-pf-copy]');
  if (copy) copy.addEventListener('click', function(){
    var code = pop.querySelector('[data-pf-code]').textContent.trim();
    var ok = function(){ copy.textContent = 'Kopierad ✓'; };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
  });
  var form = pop.querySelector('form');
  if (form) form.addEventListener('submit', function(){ set(DONE, '1'); });
  if (done) { set(DONE, '1'); open(true); return; }
  if (pop.dataset.design === 'true') {
    document.addEventListener('shopify:section:select', function(e){ if (e.target.contains(pop)) open(false); });
    document.addEventListener('shopify:section:deselect', function(e){ if (e.target.contains(pop)) close(); });
    return;
  }
  if (get(DONE) || Number(get(KEY) || 0) > Date.now()) return;
  if (/^\/(checkouts|cart|account)/.test(location.pathname)) return;
  var fired = false;
  function fire(){
    if (fired) return;
    if (busy()) { setTimeout(fire, 6000); return; }
    fired = true; open(false);
  }
  var delay = parseInt(pop.dataset.delay, 10) || 12;
  setTimeout(fire, delay * 1000);
  window.addEventListener('scroll', function onS(){
    if (window.scrollY > document.documentElement.scrollHeight * 0.45) { window.removeEventListener('scroll', onS); fire(); }
  }, { passive: true });
  document.addEventListener('mouseout', function(e){ if (!e.relatedTarget && e.clientY < 8) fire(); });
})();